class SizeGuideModal extends HTMLElement {
  constructor() {
    super();

    this.modal = this;
    this.closeButton = this.querySelector('.size-guide__close');
    this.content = this.querySelector('.size-guide__content');

    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  connectedCallback() {
    this.closeButton.addEventListener('click', this.close);
    window.addEventListener('click', this.handleOutsideClick);
  }

  disconnectedCallback() {
    this.closeButton.removeEventListener('click', this.close);
    window.removeEventListener('click', this.handleOutsideClick);
  }

  open() {
    this.style.display = 'flex';
    setTimeout(() => {
      this.content.setAttribute('open', '');
    }, 100);
  }

  close() {
    this.content.removeAttribute('open');
    setTimeout(() => {
      this.style.display = 'none';
    }, 100);
  }

  handleOutsideClick(event) {
    if (event.target === this.modal) {
      this.close();
    }
  }
}

customElements.define('size-guide', SizeGuideModal);

document.addEventListener('DOMContentLoaded', function () {
  document
    .querySelectorAll('.size-guide__button button')
    .forEach(function (button) {
      button.addEventListener('click', function () {
        document.querySelector('size-guide').open();
      });
    });
});
